import axios from 'axios';
import { handleResponse } from './HelperService';

const getAllInsertedDealers = (params, onSuccess, onError) => {
    const response = axios.get('v2/mhc-dealer/dealers-inserted', { params });
    return handleResponse(response, onSuccess, onError);
};

const getDealerOrderTypes = (params, onSuccess, onError) => {
    const response = axios.get('v2/mhc-dealer/dealer-order-types', { params });
    return handleResponse(response, onSuccess, onError);
};

export {getAllInsertedDealers, getDealerOrderTypes}